import { CreateProfilePayload } from "../types/createProfile.type";
import { SanitisableObj, sanitiseWhiteSpace } from "../../../utils";
import { AddressesPayload } from "../types/address.type";
import { UpdateProfileDetailsPayload } from "../types/profileDetails.type";

export const sanitiseCreateProfilePayload = <
  TPayload extends CreateProfilePayload | AddressesPayload | UpdateProfileDetailsPayload | null
>(
  payload: TPayload
) => {
  if (payload === null || payload === undefined) {
    return {};
  }

  const sanitisedPayload = sanitiseWhiteSpace(
    payload as unknown as SanitisableObj
  );
  return sanitisedPayload as never as TPayload;
};
